import { FormikProps } from "formik";
import { GxpReadyValue } from "./QualificationStatusSelectWithSwitch";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducers";
import { KEEP_STATUS_OPTION, KEEP_STATUS_VALUE } from "../../../../logs/StepperContainer";
import ACTION_LOGS_DATA_MODEL from "../../../../utils/constants/actionLogsDataModel";
import { OwcListItem, OwcSelectDropdown, OwcSlideToggle } from "@one/react";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";
import { useFieldPropagationToggle } from "../../../../utils/hooks/useFieldPropagationToggle";
export const SystemStatusSelectWithSwitch = ({
  formik,
  editMode,
  cluster = false,
  isPropagationDisabled,
  numberOfSelectedEquipment,
  defaultValue
}: {
  formik: FormikProps<{
    systemStatus: GxpReadyValue;
    systemStatusCluster?: GxpReadyValue;
  }>;
  cluster?: boolean;
  editMode: boolean;
  isPropagationDisabled: boolean;
  numberOfSelectedEquipment: number;
  defaultValue: string;
}) => {
  const selectedValue = cluster ? "systemStatusCluster" : "systemStatus";
  const formikObject = formik.values[selectedValue];

  const { isToggleDisabled } = useFieldPropagationToggle({
    formikValue: formikObject ?? { newValue: '', shouldBePublished: false },
    defaultValue: numberOfSelectedEquipment > 1 ? KEEP_STATUS_VALUE.value : defaultValue,
    label: selectedValue,
    setFieldValue: formik.setFieldValue,
    disabled: editMode || isPropagationDisabled
  });

  const systemStatuses = useSelector((store: RootState) => store.runLogsForm.systemStatuses) as {
    key: string;
    value: string;
  }[];
  const options = [
    ...(numberOfSelectedEquipment > 1 ? [KEEP_STATUS_OPTION] : []),
    ...systemStatuses.map(({ key, value }) => ({
      key,
      value,
      label: numberOfSelectedEquipment > 1 ? `Set all to "${value}"` : value
    }))
  ] as { key: string; value: string; label: string }[];
  return (
    <>
      <OwcSelectDropdown
        {...react18WorkaroundProps}
        style={{ width: "100%" }}
        label={`${ACTION_LOGS_DATA_MODEL.systemStatus.value} *`}
        required
        onSelectChange={(event: CustomEvent) =>
          formik.setFieldValue(`${selectedValue}.newValue`, {
            key: options[event.detail[0]].key,
            value: options[event.detail[0]].value
          })
        }
      >
        {options.map((option) => {
          return (
            <OwcListItem
              {...react18WorkaroundProps}
              key={option.key}
              selected={option.key === (formikObject?.newValue?.key || formikObject?.key)}
            >
              {option.label}
            </OwcListItem>
          );
        })}
      </OwcSelectDropdown>
      <OwcSlideToggle
        {...react18WorkaroundProps}
        checked={formikObject?.shouldBePublished}
        onInputChange={(event) => formik.setFieldValue(`${selectedValue}.shouldBePublished`, event.detail)}
        id={`${selectedValue}.shouldBePublished`}
        disabled={editMode || isPropagationDisabled || isToggleDisabled}
      >
        {`Publish “${ACTION_LOGS_DATA_MODEL.systemStatus.value}” to Equipment Repository`}
      </OwcSlideToggle>
    </>
  );
};
